import AppLayout from '../layouts/AppLayout'
import React, { useState, useEffect, useContext, useCallback, useMemo } from 'react'
import { AppContext } from '../contexts/AppContext'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Spinner from 'react-activity/dist/Spinner'
import 'react-activity/dist/Spinner.css'
import { format } from 'date-fns'
import { enUS } from 'date-fns/locale'
import { IoIosArrowForward } from 'react-icons/io'
import { FiX, FiDownload } from 'react-icons/fi'
import classNames from 'classnames'
import { getTeamImage } from '../utils/team'
import { getCompetitionImage } from '../utils/competition'

const MemberMatchDetails = () => {
  const { matchId, competition } = useParams()

  const navigate = useNavigate()

  const [match, setMatch] = useState('')
  const [type, setType] = useState('Live')
  const [isOpen, setIsOpen] = useState('')
  const [matchLinks, setmatchLinks] = useState([])
  const [linksLoading, setslinksLoading] = useState(false)
  const [liveCount, setliveCount] = useState(0)
  const [highlightCount, sethighlightCount] = useState(0)
  const [googleCount, setgoogleCount] = useState(0)
  const [totalSpectators, settotalSpectators] = useState(0)
  const [websitesLinks, setwebsitesLinks] = useState([])
  const [team1scorers, setTeam1scorers] = useState([])
  const [team2scorers, setTeam2scorers] = useState([])
  const [competitions, setCompetitions] = useState([])
  const [selectedScreenshot, setSelectedScreenshot] = useState(null)
  const [showScreenshotModal, setShowScreenshotModal] = useState(false)
  const [excelDownloading, setExcelDownloading] = useState(false)
  const STATIC_BASE_URL = process.env.REACT_APP_STATIC_URL || ''

  const { getmatch, getteamscorers, getmatchlinks, downloadmatchlinksexcel, isLoading, getCompetitions } =
    useContext(AppContext)

  const fetchCompetitions = useCallback(async () => {
    const response = await getCompetitions()
    setCompetitions(response)
  }, [getCompetitions])

  const selectedCompetition = useMemo(
    () => competitions.find((comp) => comp.id === Number(competition)),
    [competitions, competition]
  )

  useEffect(() => {
    fetchCompetitions()
  }, [fetchCompetitions])

  useEffect(() => {
    if (matchId) {
      const fetchMatch = async () => {
        const response = await getmatch(matchId)
        if (response) {
          if (response[0] !== '') {
            setMatch(response[0])

            if (response[0].team1score !== '') {
              const response4 = await getteamscorers(response[0].team1, matchId)
              setTeam1scorers(response4)
            }
            if (response[0].team2score !== '') {
              const response5 = await getteamscorers(response[0].team2, matchId)
              setTeam2scorers(response5)
            }
          } else {
            navigate('/all-matches')
          }
        } else {
          navigate('/all-matches')
        }
      }

      fetchMatch()
    }
  }, [matchId, getmatch, navigate])

  const fetchMatchlinks = async (type) => {
    setslinksLoading(true)
    const response = await getmatchlinks(type, matchId)
    setmatchLinks(response.matchlinks)
    setliveCount(response.totallive)
    sethighlightCount(response.totalhighlights)
    setgoogleCount(response.totalgoogle)
    setwebsitesLinks(response.totalwebsites)
    settotalSpectators(response.totalspectators)
    setslinksLoading(false)
  }

  useEffect(() => {
    if (matchId) {
      fetchMatchlinks(type)
    }
  }, [type, matchId])

  const linkCatcollapse = async (cat) => {
    if (cat !== isOpen) {
      setIsOpen(cat)
      const response = await getmatchlinks(cat, type, matchId)
      setmatchLinks(response)
    } else {
      setIsOpen('')
    }
  }

  const handleSetType = async (t) => {
    setType(t)
    fetchMatchlinks(t)
  }

  const handleDownloadExcel = async () => {
    if (excelDownloading) return
    try {
      setExcelDownloading(true)
      const filenameHint =
        match && match.team1name && match.team2name ? `${match.team1name}-vs-${match.team2name}` : matchId
      await downloadmatchlinksexcel(matchId, filenameHint)
    } finally {
      setExcelDownloading(false)
    }
  }

  return (
    <AppLayout pageName={`${selectedCompetition?.name}`}>
      {match !== '' ? (
        <>
          <section>
            <div className='py-5'>
              <div className='flex justify-center space-x-4 mb-10'>
                <div className='flex space-x-2 font-normal tracking-wider items-center text-white p-2 rounded-full bg-main pr-3'>
                  {match.competitionId === 1 && (
                    <img
                      alt={match.compname}
                      className='rounded-full border-4 border-white'
                      width='30'
                      height='30'
                      src={`/images/teams/ligue1.png`}
                    />
                  )}
                  {match.competitionId === 2 && (
                    <img
                      alt={match.compname}
                      className='rounded-full border-4 border-white'
                      width='30'
                      height='30'
                      src={`/images/teams/ligue2.png`}
                    />
                  )}{' '}
                  <span>{match.compname}</span>
                </div>
                <div className='text-lg tracking-wide p-2 px-5 rounded-full bg-white border text-main-alt border-main-alt'>
                  {match.status}
                </div>
              </div>
              <div className='flex flex-row flex-wrap md:flex-nowrap justify-center space-x-0 md:space-x-24 heading'>
                <div className='flex flex-col w-6/12 md:w-auto space-y-4 md:space-y-8 text-lg md:text-3xl font-bold text-main items-center text-center order-2 md:order-1'>
                  <Link to={`/team/${match.team1name.toLowerCase().replaceAll(' ', '')}/${match.team1}`}>
                    <img
                      alt={match.team1name}
                      className='w-16 h-16 md:w-24 md:h-24'
                      src={getTeamImage(match.team1logo, match.team1name)}
                    />
                  </Link>
                  <Link to={`/team/${match.team1name.toLowerCase().replaceAll(' ', '')}/${match.team1}`}>
                    <div>{match.team1name}</div>
                  </Link>
                </div>
                <div className='flex flex-col w-full md:w-auto space-y-4 text-3xl font-bold text-black text-center justify-center order-1 md:order-2 mb-6 md:mb-0'>
                  {match.matchday !== '' && (
                    <div className='text-base tracking-wide text-neutral-400 font-light'>Matchday {match.matchday}</div>
                  )}
                  <div className=''>{format(new Date(match.date), 'EEE, do MMM yyyy', { locale: enUS })}</div>
                  <div className='flex justify-center'>
                    <div className='text-lg tracking-wide p-1 px-5 rounded-full bg-neutral-100 text-neutral-800 mt-1'>
                      {match.time}
                    </div>
                  </div>
                  {match.team1score != null && match.team2score != null && (
                    <>
                      <div className='flex justify-center items-top space-x-5'>
                        <div>
                          <div
                            className={classNames({
                              'rounded py-2 w-12 text-center text-white': match.team1score != null,
                              'bg-main-alt': match.team1score > match.team2score,
                              'bg-red-700': match.team1score < match.team2score,
                              'bg-neutral-500': match.team1score !== null && match.team1score === match.team2score,
                            })}
                          >
                            {match.team1score}
                          </div>
                        </div>
                        <div className='text-lg font-bold text-neutral-500 pt-2.5'>-</div>
                        <div>
                          <div
                            className={classNames({
                              'rounded py-2 w-12 text-center text-white': match.team2score != null,
                              'bg-main-alt': match.team2score > match.team1score,
                              'bg-red-600': match.team2score < match.team1score,
                              'bg-neutral-500': match.team1score !== null && match.team1score === match.team2score,
                            })}
                          >
                            {match.team2score}
                          </div>
                        </div>
                      </div>
                      <div className='flex justify-center items-top'>
                        <div className='flex-1'>
                          {match.team1score > 0 && (
                            <div className='space-y-1 text-neutral-500 text-xs text-right font-normal normal-font'>
                              {team1scorers.map((scorer, index) => {
                                return (
                                  <div
                                    className='whitespace-nowrap'
                                    key={index}
                                  >
                                    {scorer.playername}
                                  </div>
                                )
                              })}
                            </div>
                          )}
                        </div>
                        <div className='text-lg font-bold text-neutral-500 w-11'></div>
                        <div className='flex-1'>
                          {match.team2score > 0 && (
                            <div className='space-y-1 text-neutral-500 text-xs text-left font-normal normal-font'>
                              {team2scorers.map((scorer, index) => {
                                return (
                                  <div
                                    className='whitespace-nowrap'
                                    key={index}
                                  >
                                    {scorer.playername}
                                  </div>
                                )
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <div className='flex flex-col w-6/12 md:w-auto space-y-4 md:space-y-8 text-lg md:text-3xl font-bold text-main items-center text-center order-3 md:order-3'>
                  <Link to={`/team/${match.team2name.toLowerCase().replaceAll(' ', '')}/${match.team2}`}>
                    <img
                      alt={match.team2name}
                      className='w-16 h-16 md:w-24 md:h-24'
                      src={getTeamImage(match.team2logo, match.team2name)}
                    />
                  </Link>
                  <Link to={`/team/${match.team2name.toLowerCase().replaceAll(' ', '')}/${match.team2}`}>
                    <div>{match.team2name}</div>
                  </Link>
                </div>
              </div>
            </div>
          </section>

          {/* Match Screenshots (read-only for members) */}
          {Array.isArray(match.attachments) && match.attachments.length > 0 && (
            <section className='mt-4'>
              <h2 className='text-2xl font-bold tracking-normal text-main mb-4'>Match Screenshots</h2>
              <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4'>
                {match.attachments.map((screenshot, index) => {
                  const relativeUrl = typeof screenshot === 'string' ? screenshot : screenshot.url
                  const fullUrl = `${STATIC_BASE_URL.replace(/\/$/, '')}${relativeUrl}`

                  return (
                    <button
                      key={screenshot.id || index}
                      type='button'
                      className='relative group border rounded-lg overflow-hidden focus:outline-none'
                      onClick={() => {
                        setSelectedScreenshot({ ...screenshot, fullUrl })
                        setShowScreenshotModal(true)
                      }}
                    >
                      <img
                        src={fullUrl}
                        alt={screenshot.filename || `Screenshot ${index + 1}`}
                        className='w-full h-40 md:h-48 object-cover'
                      />
                    </button>
                  )
                })}
              </div>
            </section>
          )}

          <section className='relative'>
            <button
              type='button'
              onClick={handleDownloadExcel}
              disabled={excelDownloading}
              className='btn-main-inverse absolute top-0 right-0 disabled:opacity-60 m-2'
            >
              <span>Download Excel File</span>
              {excelDownloading ? (
                <Spinner
                  size={14}
                  animating={excelDownloading}
                />
              ) : (
                <FiDownload />
              )}
            </button>
            <div className='flex flex-col lg:flex-col justify-between items-center space-x-0 lg:space-x-3'>
              <div className='text-center'>
                <h2 className='text-2xl font-bold tracking-normal text-main mb-2'>Match Links</h2>
                <div className='flex flex-row items-center space-x-3 mb-2'>
                  <div>
                    <span className='bg-blue-100 text-blue-800 text-sm font-medium px-3 py-2 rounded'>
                      Total links:{' '}
                      {liveCount + highlightCount + googleCount > 0
                        ? (liveCount + highlightCount + googleCount).toLocaleString()
                        : '0'}
                    </span>
                  </div>
                  <div>
                    <span className='bg-green-100 text-green-800 text-sm font-medium px-3 py-2 rounded'>
                      Number of Spectators:
                      {totalSpectators > 0
                        ? ` ${Intl.NumberFormat('en-US').format(parseInt(totalSpectators)).replace(/,/g, ' ')}`
                        : 0}
                    </span>
                  </div>
                </div>
              </div>
              {websitesLinks && (
                <div className='flex flex-wrap flex-row items-center justify-center mb-4'>
                  {websitesLinks.map((website, index) => {
                    return (
                      <React.Fragment key={index}>
                        <div className='flex space-x-2 border rounded p-1 pr-2 m-2 items-center'>
                          <div>
                            <img
                              width='40'
                              height='40'
                              src={`${process.env.REACT_APP_STATIC_URL || ''}${website.icon}`}
                            />
                          </div>
                          <div>
                            <h6 className='text-neutral-500 text-xs'>{website.name}</h6>
                            <h5 className='text-main-alt leading-none mt-0.5 font-bold'>
                              {website.name == 'Google' || website.name == 'Bing' ? googleCount : website.total}
                            </h5>
                          </div>
                        </div>
                      </React.Fragment>
                    )
                  })}
                </div>
              )}
            </div>
            <div className='pills w-full rounded-lg p-0 text-black font-semibold flex flex-row'>
              <button
                className={`${
                  type === 'Live' ? 'bg-white border border-b-white' : 'hover:bg-neutral-50 border-b text-neutral-500'
                } rounded-t-lg w-1/3 p-2 md:p-4 flex flex-col md:flex-row justify-center items-center space-x-0 md:space-x-2`}
                onClick={() => handleSetType('Live')}
              >
                <span>Live</span>
                <span className='bg-green-100 text-green-800 text-sm font-medium px-2.5 py-0.5 rounded'>
                  {liveCount}
                </span>
              </button>
              <button
                className={`${
                  type === 'Highlight'
                    ? 'bg-white border border-b-white'
                    : 'hover:bg-neutral-50 border-b text-neutral-500'
                } rounded-t-lg w-1/3 p-2 md:p-4 flex flex-col md:flex-row justify-center items-center space-x-0 md:space-x-2`}
                onClick={() => handleSetType('Highlight')}
              >
                <span>Highlights</span>
                <span className='bg-green-100 text-green-800 text-sm font-medium px-2.5 py-0.5 rounded'>
                  {highlightCount}
                </span>
              </button>
              <button
                className={`${
                  type === 'Google' ? 'bg-white border border-b-white' : 'hover:bg-neutral-50 border-b text-neutral-500'
                } rounded-t-lg w-1/3 p-2 md:p-4 flex flex-col md:flex-row justify-center items-center space-x-0 md:space-x-2`}
                onClick={() => handleSetType('Google')}
              >
                <span>Google & Bing</span>
                <span className='bg-green-100 text-green-800 text-sm font-medium px-2.5 py-0.5 rounded'>
                  {googleCount}
                </span>
              </button>
            </div>
            <section className='space-y-6 !rounded-t-none !border-t-0'>
              {linksLoading ? (
                <div className='flex justify-center w-full py-12'>
                  <Spinner
                    color='#CCCCCC'
                    size={24}
                  />
                </div>
              ) : (
                <div className='text-base font-normal text-neutral-800'>
                  {matchLinks.map((link, index) => {
                    return (
                      <React.Fragment key={index}>
                        <div className='flex flex-row'>
                          <div className='flex-1 truncate'>
                            <a
                              href={link.link}
                              target='_blank'
                              rel='noreferrer'
                              className='w-full'
                            >
                              <div className='flex w-full space-x-1 py-2 px-3 truncate bg-white rounded-l items-center hover:bg-neutral-200'>
                                <IoIosArrowForward size={14} /> <span className='truncate'>{link.link}</span>
                              </div>
                            </a>
                          </div>
                        </div>
                      </React.Fragment>
                    )
                  })}
                </div>
              )}
            </section>
          </section>
        </>
      ) : (
        <div className='flex justify-center w-full py-12'>
          <Spinner
            color='#CCCCCC'
            size={24}
          />
        </div>
      )}

      {/* Screenshot modal */}
      {showScreenshotModal && selectedScreenshot && (
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/70'>
          <div className='relative max-w-5xl w-full mx-4 bg-black rounded-lg overflow-hidden'>
            <button
              type='button'
              className='absolute top-3 right-3 bg-black/70 text-white rounded-full p-2 hover:bg-black focus:outline-none'
              onClick={() => {
                setShowScreenshotModal(false)
                setSelectedScreenshot(null)
              }}
            >
              <FiX size={18} />
            </button>
            <img
              src={selectedScreenshot.fullUrl}
              alt={selectedScreenshot.filename || 'Match screenshot'}
              className='w-full max-h-[80vh] object-contain bg-black'
            />
            {selectedScreenshot.filename && (
              <div className='px-4 py-2 text-sm text-neutral-200 bg-black/80'>{selectedScreenshot.filename}</div>
            )}
          </div>
        </div>
      )}
    </AppLayout>
  )
}

export default MemberMatchDetails
